import { render, staticRenderFns } from "./QuestionCreateComponent.vue?vue&type=template&id=7d74acb1&scoped=true"
import script from "./QuestionCreateComponent.vue?vue&type=script&lang=js"
export * from "./QuestionCreateComponent.vue?vue&type=script&lang=js"
import style0 from "./QuestionCreateComponent.vue?vue&type=style&index=0&id=7d74acb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d74acb1",
  null
  
)

export default component.exports